import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthStore } from '../store/auth.store';
import { CustomerStatus } from '../store/types';
import { MatSnackBar } from '@angular/material/snack-bar';

/**
 * Guard que protege las rutas de operaciones cuando el cliente está inactivo.
 * Bloquea el acceso a transferencias si el customer tiene status INACTIVE.
 */
export const customerActiveGuard: CanActivateFn = (route, state) => {
  const authStore = inject(AuthStore);
  const router = inject(Router);
  const snackBar = inject(MatSnackBar);

  const customer = authStore.customer();

  if (customer?.status === CustomerStatus.INACTIVE) {
    snackBar.open(
      'Su cuenta de cliente está inactiva. No puede realizar esta acción.',
      'Entendido',
      {
        duration: 5000,
        panelClass: ['mat-snack-error'],
        horizontalPosition: 'center',
        verticalPosition: 'top'
      }
    );

    router.navigate(['/']);
    return false;
  }

  return true;
};
